var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsInt, IsOptional, IsString, MaxLength, Min } from 'class-validator';
import { Gewinnermittlungsart } from '../../office-location-datev-settings/types/datev-enums.js';
/**
 * Body for `POST /office-locations/:officeLocationId/datev-mode-switch`
 * (PRD #1319 / RS-004).
 *
 * Switching the Gewinnermittlungsart is not an ordinary settings edit — it
 * migrates pvs-billing's export ledger (symmetric carry-over seeding) so the
 * incoming trigger does not re-book revenue DATEV already knows about. It
 * therefore lives on the export side, not on the settings foldout.
 *
 * `confirmation` must repeat the target value verbatim (`EUR` / `BILANZ`);
 * the frontend makes the user type it, and the backend re-checks it so a
 * stray click can never trigger the migration. `reason` is mandatory once the
 * settings block is frozen (after the first completed export) and is recorded
 * into the change history alongside the carry-over count.
 */
export class SwitchGewinnermittlungsartDto {
    target;
    /**
     * The target value re-typed as a confirmation guard. Must equal `target`;
     * the domain rejects the switch otherwise so a plain button click cannot
     * perform it.
     */
    confirmation;
    reason;
    /**
     * The carry-over count the user saw in the preview (PRD #1319 / RS-005).
     * The switch recomputes the plan inside its serialized transaction and,
     * when these expected counts are present, rejects the switch with a
     * `MODE_SWITCH_PREVIEW_STALE` conflict if they no longer match — so the user
     * cannot confirm on numbers that went stale between render and confirm.
     * Omitted → no staleness check (the raw RS-004 path).
     */
    expectedCarryOverCount;
    /** The fold-forward (open-receivable) count the user saw in the preview. */
    expectedFoldForwardCount;
}
__decorate([
    IsEnum(Gewinnermittlungsart),
    __metadata("design:type", String)
], SwitchGewinnermittlungsartDto.prototype, "target", void 0);
__decorate([
    IsEnum(Gewinnermittlungsart),
    __metadata("design:type", String)
], SwitchGewinnermittlungsartDto.prototype, "confirmation", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(1000),
    __metadata("design:type", Object)
], SwitchGewinnermittlungsartDto.prototype, "reason", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(0),
    __metadata("design:type", Object)
], SwitchGewinnermittlungsartDto.prototype, "expectedCarryOverCount", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(0),
    __metadata("design:type", Object)
], SwitchGewinnermittlungsartDto.prototype, "expectedFoldForwardCount", void 0);
//# sourceMappingURL=switch-gewinnermittlungsart.dto.js.map